// extracted by mini-css-extract-plugin
module.exports =  {"updates":"updates--nOMWj","actions":"actions--l0TAO"};